<div class="width-100">
  <div [ngClass]="!embeddedComponent ? 'adv-header' : 'adv-header-comp-class'">
    <a
      class="adv-header-label"
      tabindex="0"
      (click)="toggleFilter()"
      (keyup.enter)="toggleFilter()"
      >{{ filter?.title }}</a
    >
    <span class="adv-header-icon pull-right">
      <i
        tabindex="0"
        title="{{ filter.show ? 'Collapse' : 'Expand' }} {{ filter.title }}"
        [ngClass]="filter.show ? 'fa fa-compress' : 'fa fa-expand'"
        (click)="toggleFilter()"
        (keyup.enter)="toggleFilter()"
      >
      </i>
    </span>
  </div>
  @if (show) {
    <div class="adv-fields">
      <ul class="target-list">
        <li class="target-heading">
          <ul class="target-list-ul" style="clear: both; display: inline-block; width: 100%">
            @for (options of filter.dropdownFields; track options) {
              <li
                class="target-list-li col-12"
                [ngClass]="{ 'col-md-6 col-lg-4': !embeddedComponent }"
              >
                <label>
                  <input
                    type="checkbox"
                    [class]="'filter' + filter.filterId"
                    [value]="options.value"
                    [name]="options.name"
                    [checked]="options.selected"
                    (change)="selectFilter($event, filter.filterIndex)"
                  />
                  <span
                    >{{ options.name }} <small>( {{ options.count }} )</small></span
                  >
                </label>
              </li>
            }
          </ul>
        </li>
      </ul>
    </div>
  }
</div>
